import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';
import { labelClassName } from '@archipro-design/aria';
import { flexClassName } from '@archipro-design/aria';
import {
    mobileHeaderSectionClassName,
    mobileHeaderSectionSlotClassNames,
} from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import { animationClassName } from '@fluentui/react-northstar';

export const MobileHeader: StyleRule = ({ theme }) => ({
    [`& .${mobileHeaderSectionClassName}`]: {
        minHeight: pxToRem(68),
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',

        [`& > div`]: {
            background: 'transparent',
            position: 'relative',
            margin: 0,
        },

        [`& > div > .${flexClassName}`]: {
            width: pxToRem(338),
            margin: 0,
            height: 'unset',
            [`& > .${flexClassName}`]: {
                margin: pxArrayToRem([0, 0, 0, 36]),
                position: 'relative',
                top: 0,
                left: 0,
                display: 'flex',
                flexDirection: 'column',
                alignContent: 'center',
                alignItems: 'center',
                transform: 'unset',
            },
        },

        [`& .${labelClassName}`]: {
            fontSize: pxToRem(20),
            ...theme.siteVariables.textStyles.Heading.Medium65,
            lineHeight: 1,
            letterSpacing: theme.siteVariables.letterSpacingNormal,
            textTransform: 'uppercase',
        },

        [`& .${mobileHeaderSectionSlotClassNames.subtitle}`]: {
            color: theme.siteVariables.colorScheme.default?.['foreground5'],
            lineHeight: 1,
            margin: 0,
        },

        [`& .${animationClassName}:empty`]: {
            display: 'none',
        },
    },
});

export const MobileHeaderBackSection: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([24, 14.5, 0]),
    marginBottom: pxToRem(-4),

    [`& .${buttonClassName}`]: {
        [`& .${svgIconClassName}`]: {
            transform: `rotate(90deg)`,
            width: pxToRem(10),
            height: pxToRem(10),
        },

        [`& .${labelClassName}`]: {
            paddingLeft: pxToRem(4),
            textTransform: 'uppercase',
            ...theme.siteVariables.textStyles.Heading.Roman55,
        },
    },
});
